import React, { useState } from 'react';

import Button from 'shared/button';
import ContactSelector from 'bundles/backoffice/contacts/selector';
import Modal from 'components/modal';

import type { Contact, ContactRole, Visibility } from 'bundles/backoffice/contacts/types';

interface Props {
  contactRole: ContactRole;
  show: boolean;
  newContactVisibility?: Visibility;
  onChange: (contactRole: ContactRole) => void;
  onHide: () => void;
}

export default function ReplaceContactModal({ contactRole, newContactVisibility, show, onChange, onHide }: Props) {
  const [contact, setContact] = useState<Contact | null>(null);

  function handleChange(contact: Contact, isNewContact: boolean) {
    setContact(contact);

    if (isNewContact) {
      save(contact);
    }
  }

  function save(contact: Contact) {
    onChange({ ...contactRole, contact });
    onHide();
  }

  function reset() {
    setContact(null);
  }

  return (
    <Modal centered show={show} size="lg" onHide={onHide} onShow={reset}>
      <Modal.Header closeButton onHide={onHide}>
        Replace {contactRole.roleLabel}
      </Modal.Header>

      <Modal.Body>
        <label>Select a new {contactRole.roleLabel.toLowerCase()}</label>
        <ContactSelector
          allowTagging
          contact={contact}
          modalBackdrop={false}
          newContactVisibility={
            newContactVisibility || (contactRole.contact.visibility === 'private' ? 'private' : 'public')
          }
          onChange={handleChange}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel onClick={onHide} />
        <Button.Primary
          disabled={!contact}
          label={`Replace ${contactRole.roleLabel}`}
          onClick={contact ? () => save(contact) : null}
        />
      </Modal.Footer>
    </Modal>
  );
}
